<div class="modal-header">
	<h4 class="modal-title">Файлы сайта: {{title}}</h4>
	<button type="button" class="close" aria-label="Close" (click)="close()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-body">
	<loading [isLoad]="isLoading"></loading>

	<div *ngIf="!isLoading && files.length === 0" class="alert alert-info">
		Загруженных файлов не найдено
	</div>

	<div *ngIf="!isLoading && files.length > 0">
		<p>Найдено файлов: <strong>{{files.length}}</strong></p>

		<div class="form-group">
			<label>Комментарий (обязателен для удаления)</label>
			<input type="text" class="form-control" [(ngModel)]="comment" placeholder="Причина удаления файла (мин. 10 символов)">
		</div>

		<table class="table table-sm table-striped">
			<thead>
				<tr>
					<th>Имя файла</th>
					<th>Папка</th>
					<th>Размер</th>
					<th>Изменён</th>
					<th>Путь</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let file of files">
					<td>{{file.name}}</td>
					<td>
						<span class="badge" [ngClass]="{
							'badge-primary': file.folder === 'file',
							'badge-success': file.folder === 'img',
							'badge-warning': file.folder === 'doc'
						}">{{file.folder}}</span>
					</td>
					<td>{{formatFileSize(file.size)}}</td>
					<td>{{file.modified | date:'dd.MM.yyyy HH:mm'}}</td>
					<td style="max-width: 200px; word-break: break-all;">
						<a [href]="file.path" target="_blank">{{file.path}}</a>
					</td>
					<td>
						<button
							class="btn btn-sm btn-danger"
							(click)="deleteFile(file)"
							[disabled]="deletingFile === (file.folder + '/' + file.name)"
						>
							<span *ngIf="deletingFile === (file.folder + '/' + file.name)">...</span>
							<span *ngIf="deletingFile !== (file.folder + '/' + file.name)">Удалить</span>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-default" (click)="close()">Закрыть</button>
</div>
